// Views
import Main from 'src/views/Main.vue';
import Meditations from 'src/views/Meditation/Meditations.vue';
import MeditationShow from 'src/views/Meditation/MeditationShow.vue';
import People from 'src/views/Person/People.vue';
import PersonShow from 'src/views/Person/PersonShow.vue';
import PersonEdit from 'src/views/Person/PersonEdit.vue';

import PersonNew from 'src/views/Person/PersonNew.vue';
import Locations from 'src/views/Locations/Index.vue';
import LocationCreate from 'src/views/Locations/Create.vue';
import LocationEdit from 'src/views/Locations/Edit.vue';
import BibleStudies from 'src/views/BibleStudies/All.vue';
import BibleStudiesShow from 'src/views/BibleStudies/Show.vue';
import BibleStudyPlan from 'src/views/BibleStudyPlan/BibleStudyPlans.vue';
import BibleStudyPlanEdit from 'src/views/BibleStudyPlan/BibleStudyPlanEdit.vue';
// import Regional from 'src/views/Regional.vue';
import ReportingPercentagesShow from 'src/views/ReportingPercentages/Show.vue';
import DepthChart from 'src/views/DepthChart/Show.vue';
import Discipleship from 'src/views/Discipleship/Discipleship.vue';
import DiscipleshipGroups from 'src/views/DiscipleshipGroup/DiscipleshipGroups.vue';
import Reporting from 'src/views/Reporting/Show.vue';
import GraduationRecords from 'src/views/GraduationRecords/Show.vue';
import RegionalGraduationRecords from 'src/views/GraduationRecords/ShowRegional.vue';
// import Meditations from 'src/views/Meditation/Meditations.vue';
import Login from 'src/views/Login.vue';
import Logout from 'src/views/Logout.vue';
import AccessDenied from 'src/views/AccessDenied.vue';
import InterestRecordForm from 'src/views/InterestRecordForm.vue';
import Callback from 'src/views/Callback.vue';
import NoAccount from 'src/views/NoAccount.vue';
import NoAccountNonStudent from 'src/views/NoAccountNonStudent.vue';
import ExpiredToken from 'src/views/ExpiredToken.vue';
import SyncClock from 'src/views/SyncClock.vue';
import NotFound from 'src/views/NotFoundPage.vue';
import DashboardLayout from 'src/components/Layout/DashboardLayout.vue';
import MaintenanceMode from 'src/views/MaintenanceMode.vue';
import RecruitmentDepthChart from 'src/views/RecruitmentDepthChart/Show.vue';

import Delegations from 'src/views/Delegations/Index.vue';
import Invitations from 'src/views/Invitations/Invitations.vue';

const loginPage = {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
        requiresAuth: false
    }
};

const callbackPage = {
    path: '/callback',
    name: 'Callback',
    component: Callback,
    meta: {
        requiresAuth: false
    }
};

const logoutPage = {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {
        requiresAuth: false
    }
};

const accessDenied = {
    path: '/accessdenied',
    name: 'accessdenied',
    component: AccessDenied,
    meta: {
        requiresAuth: false
    }
};

const noAccountPage = {
    path: '/no-account',
    name: 'noaccount',
    component: NoAccount,
    meta: {
        requiresAuth: false
    }
};

const noAccountNonStudentPage = {
    path: '/no-account-non-student',
    name: 'noaccountnonstudent',
    component: NoAccountNonStudent,
    meta: {
        requiresAuth: false
    }
};

const expiredTokenPage = {
    path: '/expired-token',
    name: 'expiredtoken',
    component: ExpiredToken,
    meta: {
        requiresAuth: false
    }
};

const syncClockPage = {
    path: '/sync-clock',
    name: 'syncclock',
    component: SyncClock,
    meta: {
        requiresAuth: false
    }
};

const interestRecordFormPage = {
    path: '/registration/:id',
    name: 'InterestRecordForm',
    component: InterestRecordForm,
    meta: {
        requiresAuth: false
    }
};

const routes = [
    // remove comment in following line to set vue into maintenance mode
    // { path: '/*', component: MaintenanceMode }, // you need an asterisk after the slash
    {
        path: '/',
        component: DashboardLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: 'main',
                name: 'Main',
                component: Main
            },
            {
                path: 'bible-studies',
                name: 'BibleStudies',
                component: BibleStudies
            },
            {
                path: 'bible-studies/:id',
                name: 'BibleStudiesView',
                component: BibleStudiesShow
            },
            {
                path: 'reporting',
                name: 'Reporting',
                component: Reporting
            },
            // {
            //     path: 'bible-studies/:id/edit',
            //     name: 'BibleStudiesEdit',
            //     component: BibleStudiesEdit
            // },
            // {
            //     path: 'regional',
            //     name: 'Regional',
            //     component: Regional,
            //     meta: {
            //         requiresAuth: true,
            //         role: ['Regional']
            //     },
            // },
            {
                path: 'reporting-percentages',
                name: 'Reporting Percentages',
                component: ReportingPercentagesShow
            },
            {
                path: 'meditations',
                name: 'Meditation',
                component: Meditations
            },
            {
                path: 'meditations/:id',
                name: 'MeditationShow',
                component: MeditationShow
            },
            {
                path: 'people',
                name: 'People',
                component: People
            },
            {
                path: 'people/create',
                name: 'PersonNew',
                component: PersonNew
            },
            {
                path: 'people/:id',
                name: 'PersonShow',
                component: PersonShow
            },
            {
                path: 'people/:id/edit',
                name: 'PersonEdit',
                component: PersonEdit
            },
            {
                path: 'discipleship',
                name: 'Discipleship',
                component: Discipleship,
            },
            {
                path: 'discipleship-groups',
                name: 'DiscipleshipGroups',
                component: DiscipleshipGroups,
            },
            {
                path: 'invitations',
                name: 'Invitations',
                component: Invitations,
            },
            {
                path: 'depth-chart',
                name: 'DepthChart',
                component: DepthChart,
            },
            {
                path: 'recruitment-depth-chart',
                name: 'RecruitmentDepthChart',
                component: RecruitmentDepthChart,
            },
            {
                path: 'bible-study-plans',
                name: 'BibleStudyPlan',
                component: BibleStudyPlan,
            },
            {
                path: 'bible-study-plans/:id/edit',
                name: 'BibleStudyPlanEdit',
                component: BibleStudyPlanEdit
            },
            {
                path: 'graduation-records',
                name: 'GraduationRecords',
                component: GraduationRecords
            },
            {
                path: 'regional-graduation-records',
                name: 'RegionalGraduationRecords',
                component: RegionalGraduationRecords
            },
            {
                path: 'locations',
                name: 'Locations',
                component: Locations
            },
            {
                path: 'locations/create',
                name: 'LocationCreate',
                component: LocationCreate
            },
            {
                path: 'locations/:id/edit',
                name: 'LocationEdit',
                component: LocationEdit
            },
            {
                path: 'delegations',
                name: 'Delegations',
                component: Delegations
            },
        ],

    },
    loginPage,
    callbackPage,
    logoutPage,
    accessDenied,
    noAccountPage,
    noAccountNonStudentPage,
    expiredTokenPage,
    syncClockPage,
    interestRecordFormPage,
    { path: '*', component: NotFound }
];

export default routes;
